export default "__VITE_ASSET__DtXWd4L8__"